import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';

function mapStateToProps(state) {
    const {language, locale, messages} = state.intl;
    
    return {
        locale,
        messages,
        key: `${language}-${locale}`
    };
}

export default connect(mapStateToProps)(IntlProvider);
